import { CheckCircle, Warning, XCircle } from "@phosphor-icons/react";

function fmtBytes(n) {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  return `${(n / 1024).toFixed(2)} KB`;
}

export default function CompatibilityPanel({ result }) {
  if (!result) {
    return (
      <div
        className="p-6 hairline bg-white"
        data-testid="compat-empty"
      >
        <div className="micro-label mb-3">Livery Compatibility</div>
        <div className="text-[var(--fg-2)] text-sm">
          Upload and convert an image to see compatibility diagnostics.
        </div>
      </div>
    );
  }

  const size = result.size_bytes;
  const ok = result.compatible;
  const Icon = ok ? CheckCircle : XCircle;
  const iconCls = ok ? "text-[var(--success)]" : "text-[var(--accent)]";

  return (
    <div className="bg-white hairline" data-testid="compat-panel">
      <div className="flex items-center justify-between p-5 border-b border-[var(--border)]">
        <div className="flex items-center gap-3">
          <Icon size={22} weight="fill" className={iconCls} />
          <div>
            <div className="font-display font-bold text-base">
              {ok ? "Livery Ready" : "Needs Attention"}
            </div>
            <div className="text-xs text-[var(--fg-2)] font-mono">
              {ok ? "Upload to Sport Mode livery editor" : "Adjust settings below"}
            </div>
          </div>
        </div>
        <span className={`chip ${ok ? "" : "border-[var(--accent)] text-[var(--accent)]"}`}>
          <span className={`status-dot ${ok ? "ok" : "err"}`}></span>
          {ok ? "PASS" : "FAIL"}
        </span>
      </div>

      <div className="grid grid-cols-3 divide-x divide-[var(--border)]">
        <Stat label="Size" value={fmtBytes(size)} sub={`limit 15.00 KB`} warn={size > 15 * 1024} />
        <Stat label="Paths" value={result.path_count} sub="limit ~1000" warn={result.path_count > 1000} />
        <Stat label="Colors" value={result.colors_used} sub="used" />
      </div>

      {result.warnings && result.warnings.length > 0 && (
        <div className="border-t border-[var(--border)] p-5 space-y-2" data-testid="compat-warnings">
          {result.warnings.map((w, i) => (
            <div key={i} className="flex items-start gap-2 text-sm">
              <Warning size={16} weight="fill" className="text-[var(--warning)] mt-0.5 shrink-0" />
              <span>{w}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, sub, warn }) {
  return (
    <div className="p-5">
      <div className="micro-label">{label}</div>
      <div
        className={`font-display font-black text-2xl mt-1 ${
          warn ? "text-[var(--accent)]" : ""
        }`}
      >
        {value}
      </div>
      <div className="text-[10px] font-mono text-[var(--fg-2)] mt-1 tracking-widest uppercase">
        {sub}
      </div>
    </div>
  );
}
